// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://cpnxwtiyemsrigrtetmd.supabase.co";
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNwbnh3dGl5ZW1zcmlncnRldG1kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE5ODk0ODYsImV4cCI6MjA2NzU2NTQ4Nn0.b8ZwtLIXbyaYrYcoxw3NSta-nDKMCnYnFr3liJjTe7c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});